// @ts-nocheck
// Styled MUI primitives extracted verbatim from Dashboard.tsx — behavior-identical.
// (@ts-nocheck mirrors the original Dashboard.tsx, which suppressed the custom
// `hidebackground` styled-prop type — kept to preserve behavior exactly.)
import { CANCELLED_EVENT_ROW_SX } from "../../../utils/methods/eventPresentation";
import { styled } from "@mui/material/styles";
import Select from "@mui/material/Select";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import PaginationItem from "@mui/material/PaginationItem";
import { createDraggableHeaderCell } from "../../../components/Table/createDraggableHeaderCell";

export const StyledSelect = styled(Select)(({ theme }) => ({
  border: "1px solid white",
  borderRadius: "0.4rem",
  height: "3rem",
  padding: "1.5%",
  color: "white",
  "& .MuiSelect-icon": { color: "white" },
  "& .MuiSelect-root": { borderColor: "white" },
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    position: "relative",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  display: "table-cell",
}));

/** Header cell that can be dragged onto another header to reorder the column. */
export const DraggableHeaderCell = createDraggableHeaderCell(StyledTableCell);

export const StyledTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== "hidebackground",
})(({ theme, hidebackground }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&.rejected": {
    backgroundColor: "#ed101070",
  },
  ...CANCELLED_EVENT_ROW_SX,
  "& > .MuiTableCell-root": {
    ...(hidebackground
      ? { backgroundColor: "transparent", backgroundImage: "none" }
      : {}),
  },
  transition: "background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
  "&:hover": {
    boxShadow: "0px 4px 10px rgba(255, 255, 255, 0.1)",
    transform: "scale(1.0001)",
    zIndex: 10,
    "& > .MuiTableCell-root": {
      backgroundColor: "#545454 !important",
      backgroundImage: "none",
    },
  },
}));

export const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.MuiPaginationItem-root": {
    color: theme.palette.common.white,
  },
  "&.Mui-selected": {
    color: theme.palette.secondary.main,
  },
}));
